import {
    AppstoreAddOutlined,
    AppstoreOutlined,
    HomeOutlined,
    LogoutOutlined,
    OrderedListOutlined,
    ProfileOutlined,
    UserOutlined,
    SearchOutlined,
    BulbOutlined,
    FileSearchOutlined,
    GlobalOutlined,
    CloudUploadOutlined,
    OpenAIOutlined,
    SisternodeOutlined,
    DockerOutlined,
} from "@ant-design/icons";
import { Divider, Menu, message, Switch, Typography, Popover } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import useDarkMode from "../../hooks/useDarkMode";
import useProDashboard from "../../hooks/useProDashboard";
import HTTPClient from "../../utils/HTTPClient";
import { AppboxLanguageSelect } from "../../components";
import { DashboardProSelect } from "../../components";
import { useTranslation } from "react-i18next";

const { SubMenu } = Menu;

const getItem = (label, key, icon, onClick, children) => {
    return {
        key,
        icon,
        children,
        onClick,
        label,
    };
};

const ProAppSider = (props) => {
    const [user, setUser] = useLocalStorage("user", null);
    const [selectedKeys, setSelectedKeys] = useState(["3"]);
    const [openKeys, setOpenKeys] = useState([]);
    const [darkMode, toggleDarkMode] = useDarkMode();
    const [proDashboard, toggleProDashboard] = useProDashboard();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const executeLogout = async () => {
        HTTPClient.post("/auth/logout")
            .then((res) => {
                message.success(t("pro_sider.logout.success"));
                setUser(null);
                navigate("/login");
            })
            .catch((e) => {
                message.error(t("pro_sider.logout.error"));
            });
    };

    const moveTo = (route) => {
        navigate(route);
    };

    const items = [
        getItem(t("pro_sider.items.home"), "3", <HomeOutlined />, () => moveTo("/pro/home")),

        getItem(t("pro_sider.items.app"), "sub2", <AppstoreOutlined />, () => { }, [
            getItem(t("pro_sider.items.app_store"), "4", <AppstoreAddOutlined />, () => moveTo("/pro/app")),
            getItem(t("pro_sider.items.my_apps"), "5", <OrderedListOutlined />, () =>
                moveTo("/pro/myapps")
            ),
        ]),

        getItem(t("pro_sider.items.domains"), "sub3", <SearchOutlined />, () => { }, [
            getItem(t("pro_sider.items.buy_domain"), "6", <FileSearchOutlined />, () =>
                moveTo("/pro/domains/purchase")
            ),
            getItem(t("pro_sider.items.my_domains"), "7", <OrderedListOutlined />, () =>
                moveTo("/pro/domains")
            ),
        ]),

        getItem(t("pro_sider.items.builder"), "sub4", <GlobalOutlined />, () => { }, [
            getItem(t("pro_sider.items.builder_create"), "9", <CloudUploadOutlined />, () =>
                moveTo("/pro/builder/create")
            ),
            getItem(t("pro_sider.items.builder_list"), "10", <OrderedListOutlined />, () =>
                moveTo("/pro/builder/list")
            ),
        ]),

        getItem(`${user?.name} ${user?.surname || ""}`, "sub1", <UserOutlined />, () => { }, [
            getItem(t("sider.items.profile"), "1", <ProfileOutlined />, () => moveTo("/profile")),

            getItem(t("sider.items.logout"), "8", <LogoutOutlined />, executeLogout),
        ]),
    ];

    useEffect(() => {
        setSelectedKey(window.location.pathname);
    }, [window.location.pathname]);

    const setSelectedKey = (pathname) => {
        const isPresent = PATHNAME_MAP[pathname];
        if (isPresent) {
            setSelectedKeys(isPresent);
            setOpenKeys(isPresent.slice(0, -1)); // Apre i sottomenu fino all'ultimo livello
        } else {
            if (pathname.startsWith("/create-app")) {
                setSelectedKeys(PATHNAME_MAP["/app"]);
                setOpenKeys(PATHNAME_MAP["/app"].slice(0, -1));
            }
            if (pathname.startsWith("/myapps")) {
                setSelectedKeys(PATHNAME_MAP["/myapps"]);
                setOpenKeys(PATHNAME_MAP["/myapps"].slice(0, -1));
            }
            if (pathname.startsWith("/builder/create")) {
                setSelectedKeys(PATHNAME_MAP["/builder/create"]);
                setOpenKeys(PATHNAME_MAP["/builder/create"].slice(0, -1));
            }
        }
    };

    const PATHNAME_MAP = {
        "/profilo": ["sub1", "1"],

        "/pro/home": ["3"],

        "/pro/app": ["sub2", "4"],
        "/pro/myapps": ["sub2", "5"],

        "/pro/domains/purchase": ["sub3", "6"],
        "/pro/domains": ["sub3", "7"],

        "/pro/builder/create": ["sub4", "9"],
        "/pro/builder/list": ["sub4", "10"],
    };

    const handleOpenChange = (keys) => {
        setOpenKeys(keys);
    };

    return (
        <Menu
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
            mode="inline"
            theme="light"
            style={{
                height: "100vh",
                borderRight: 0,
            }}>
            {items.map((item) =>
                item.children ? (
                    <SubMenu key={item.key} icon={item.icon} title={item.label}>
                        {item.children.map((subItem) => (
                            <Menu.Item
                                key={subItem.key}
                                icon={subItem.icon}
                                onClick={subItem.onClick}>
                                {subItem.label}
                            </Menu.Item>
                        ))}
                    </SubMenu>
                ) : (
                    <Menu.Item key={item.key} icon={item.icon} onClick={item.onClick}>
                        {item.label}
                    </Menu.Item>
                )
            )}
            <Divider />


            {props.showLang && (
                <div style={{ display: "flex", justifyContent: "flex-start", paddingLeft: "24px" }}>
                    <AppboxLanguageSelect />
                </div>
            )}
        </Menu>
    );
};

export default ProAppSider;
